/**
 * Three Panel Layout Component
 *
 * Main dashboard layout with:
 * - Left Panel: Monitoring (Like Gauge, TikTok Test, Comments, Performance)
 * - Center Panel: Character display area
 * - Right Panel: Controls (Emotion, Eye, Mouth, Body, BGM, Camera, etc.)
 */

import React from 'react';
import { LeftPanel } from './LeftPanel.js';
import { CenterPanel } from './CenterPanel.js';
import { RightPanel } from './RightPanel.js';
import { ThreeBackground } from './ThreeBackground.js';
import './ThreePanelLayout.css';

export const ThreePanelLayout: React.FC = () => {
    return (
        <div className="three-panel-layout">
            {/* Three.js Background - rendered directly without Suspense */}
            <ThreeBackground />

            {/* Main Content */}
            <div className="panel-container">
                {/* Left Panel - Monitoring */}
                <LeftPanel />

                {/* Center Panel - Character */}
                <CenterPanel />

                {/* Right Panel - Controls */}
                <RightPanel />
            </div>
        </div>
    );
};

export default ThreePanelLayout;
